// extracted by mini-css-extract-plugin
module.exports = {"Name":"Explore_2_3_img_Name__2BaiZ","NameBox":"Explore_2_3_img_NameBox__1Kdve"};